import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from './store/hooks';
import { Loader } from './components/Loader';
import { Table } from './components/Table';
import { Header } from './components/Header';
import { Toast } from './components/Toast';
import { ThemeToggle } from './components/ThemeToggle';
import { InfoModal } from './components/InfoModal';
import { useShortcuts } from './hooks/useShortcuts';
import { getWebsitesData } from './features/table/table.slice';

export function App() {
  const dispatch = useAppDispatch();
  const requestError = useAppSelector((state) => state.app.requestError);
  const websitesDataLoaded = useAppSelector(
    (state) => state.table.websitesDataLoaded,
  );

  useShortcuts();

  useEffect(() => {
    void dispatch(getWebsitesData());
  }, [dispatch]);

  if (requestError) {
    return (
      <section data-qa="loadError">
        <div className="full-height">
          <h1>Failed to load websites data</h1>
          <p>{requestError}</p>
        </div>
      </section>
    );
  }

  if (websitesDataLoaded === false) {
    return (
      <section data-qa="loader">
        <Loader fixed={true} />
      </section>
    );
  }

  return (
    <section data-qa="app" className="app">
      <Header />
      <ThemeToggle />
      <Table />
      <Toast />
      <InfoModal />
    </section>
  );
}
